module.exports = __webpack_public_path__ + "img/onlinePlatformTable-sm.b1ebaaff.svg";